module.exports = __webpack_public_path__ + "img/exclamation-square.731b67ff.svg";